var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcClockGrey = function SvgIcClockGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "clock (2)")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-(2)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)",
    fill: "#2B2B2D",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C4.26148989,0 0,4.26148989 0,9.5 C0,14.7385101 4.26148989,19 9.5,19 C14.7385101,19 19,14.7385101 19,9.5 C19,4.26148989 14.7385101,0 9.5,0 Z M14.0180664,14.4138031 C13.8636856,14.5681839 13.6610336,14.6458817 13.4583817,14.6458817 C13.2557297,14.6458817 13.0529328,14.5681839 12.8986969,14.4138031 L8.94031526,10.4555664 C8.79144287,10.3075638 8.70838166,10.1063614 8.70838166,9.89588166 L8.70838166,4.75 C8.70838166,4.31222534 9.06295012,3.95838166 9.5,3.95838166 C9.93704987,3.95838166 10.2916183,4.31222534 10.2916183,4.75 L10.2916183,9.56813051 L14.0180664,13.2944336 C14.3275528,13.6040649 14.3275528,14.1043167 14.0180664,14.4138031 L14.0180664,14.4138031 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClockGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clock_grey.77849ead.svg";
export { ForwardRef as ReactComponent };